// Components
import { Box, Flex, Text } from 'yard-utilities/components'

// Icons
import { LikeIcon, HeartIcon, CommentIcon } from 'icons/v25/Icons'

// Styles
import styles from '../FacebookReviewCard.module.sass'

export interface FooterElementProps {
  comments: number
  likes?: number
  only?: 'hearts' | 'likes' | string
}

const FooterElement = ({ comments, likes = 3, only }: FooterElementProps) => {
  return (
    <Box padding={{ sm: [10, 16] }} className={styles.cardFooter}>
      <Flex alignItems="center" justifyContent="space-between">
        <Flex alignItems="center" columnGap={{ sm: 8 }}>
          <Flex>
            {only == 'hearts' ? (
              <HeartIcon size={18} />
            ) : only == 'likes' ? (
              <LikeIcon size={18} />
            ) : (
              <>
                <LikeIcon size={20} className={styles.likeIcon} />
                <HeartIcon size={20} className={styles.heartIcon} />
              </>
            )}
          </Flex>

          <Text
            tagName="p"
            variant="body-7"
            textColor="grey-1"
            fontFamily="segoe"
          >
            {likes}
          </Text>
        </Flex>

        <Flex columnGap={{ sm: 8 }} center>
          <Text
            tagName="p"
            variant="body-7"
            textColor="grey-1"
            fontFamily="segoe"
          >
            {comments}
          </Text>
          <CommentIcon />
        </Flex>
      </Flex>
    </Box>
  )
}

export default FooterElement
